import { HTMLAttributes } from 'react';

/**
 * @public
 * https://www.notion.so/croquis/6f19e633ce494c71be69fb20e43eda79?v=04a8e30140264acca97e7a6a778b6437&pvs=4
 */
export enum PDPCustomAttributeKeys {
  PDP_SHOP_NAME_1 = 'PDP_SHOP_NAME_1',
  PDP_REVIEW_COUNT_2 = 'PDP_REVIEW_COUNT_2',
  PDP_BOTTOM_REVIEW_COUNT_3 = 'PDP_BOTTOM_REVIEW_COUNT_3',
  PDP_LIKE_BUTTON_6 = 'PDP_LIKE_BUTTON_6',
  PDP_PURCHASE_BUTTON_7 = 'PDP_PURCHASE_BUTTON_7',
  PDP_DIRECT_PURCHASE_10 = 'PDP_DIRECT_PURCHASE_10',
  PDP_CART_11 = 'PDP_CART_11',
  PDP_PRODUCT_OPTIONS_12 = 'PDP_PRODUCT_OPTIONS_12',
  PDP_REVIEW_TAB_13 = 'PDP_REVIEW_TAB_13',
  PDP_REVIEW_TAB_RATING_14 = 'PDP_REVIEW_TAB_RATING_14',
  PDP_REVIEW_TAB_CNT_15 = 'PDP_REVIEW_TAB_CNT_15',
  PDP_REVIEW_TAB_PHOTO_REVIEW_16 = 'PDP_REVIEW_TAB_PHOTO_REVIEW_16',
  PDP_REVIEW_TAB_SEE_ALL_17 = 'PDP_REVIEW_TAB_SEE_ALL_17',
  PDP_REVIEW_TAB_GROUP_18 = 'PDP_REVIEW_TAB_GROUP_18',
  PDP_REVIEW_TAB_REVIEWER_19 = 'PDP_REVIEW_TAB_REVIEWER_19',
  PDP_REVIEW_TAB_THUMBNAIL_20 = 'PDP_REVIEW_TAB_THUMBNAIL_20',
  PDP_REVIEW_TAB_DELIVERY_LABEL_21 = 'PDP_REVIEW_TAB_DELIVERY_LABEL_21',
  PDP_REVIEW_SEE_ALL_22 = 'PDP_REVIEW_SEE_ALL_22',
}

/**
 * @public
 * https://www.notion.so/croquis/6f19e633ce494c71be69fb20e43eda79?v=fc026fac44ec448bbd07c39fb0b9725f&pvs=4
 */
export enum EventCustomAttributeKeys {
  EVENT_IMAGE_MAP_POINTER_9 = 'EVENT_IMAGE_MAP_POINTER_9',
  EVENT_IMAGE_CAROUSEL_PAGINATION_24 = 'EVENT_IMAGE_CAROUSEL_PAGINATION_24',
  EVENT_IMAGE_CAROUSEL_25 = 'EVENT_IMAGE_CAROUSEL_25',
  EVENT_IMAGE_SLIDE_POINTER_27 = 'EVENT_IMAGE_SLIDE_POINTER_27',
  EVENT_IMAGE_RAIL_POINTER_29 = 'EVENT_IMAGE_RAIL_POINTER_29',
  EVENT_QUICK_CAROUSEL_TYPE_A_MARKER_31 = 'EVENT_QUICK_CAROUSEL_TYPE_A_MARKER_31',
  EVENT_QUICK_CAROUSEL_TYPE_A_IMAGE_POINTER_32 = 'EVENT_QUICK_CAROUSEL_TYPE_A_IMAGE_POINTER_32',
  EVENT_QUICK_CAROUSEL_TYPE_B_IMAGE_POINTER_33 = 'EVENT_QUICK_CAROUSEL_TYPE_B_IMAGE_POINTER_33',
  EVENT_QUICK_CAROUSEL_TYPE_B_MARKER_34 = 'EVENT_QUICK_CAROUSEL_TYPE_B_MARKER_34',
  EVENT_CONTENT_ACTION_3_MAIN_35 = 'EVENT_CONTENT_ACTION_3_MAIN_35',
  EVENT_CONTENT_ACTION_3_BUTTON_36 = 'EVENT_CONTENT_ACTION_3_BUTTON_36',
  EVENT_PAGE_TAB_37 = 'EVENT_PAGE_TAB_37',
  EVENT_TAB_BUTTON_38 = 'EVENT_TAB_BUTTON_38',
  EVENT_PRODUCT_CHIP_BUTTON_39 = 'EVENT_PRODUCT_CHIP_BUTTON_39',
  EVENT_PRODUCT_MORE_BUTTON_40 = 'EVENT_PRODUCT_MORE_BUTTON_40',
  EVENT_SCROLL_TAB_41 = 'EVENT_SCROLL_TAB_41',
  EVENT_RELATED_CONTENT_45 = 'EVENT_RELATED_CONTENT_45',
  EVENT_RELATED_CONTENT_MAIN_46 = 'EVENT_RELATED_CONTENT_MAIN_46',
  EVENT_RELATED_CONTENT_IMAGE_47 = 'EVENT_RELATED_CONTENT_IMAGE_47',
  EVENT_RELATED_CONTENT_TITLE_48 = 'EVENT_RELATED_CONTENT_TITLE_48',
  EVENT_PRODUCT_CARD_49 = 'EVENT_PRODUCT_CARD_49',
  EVENT_PRODUCT_CARD_IMAGE_50 = 'EVENT_PRODUCT_CARD_IMAGE_50',
  EVENT_PRODUCT_CARD_STORE_NAME_51 = 'EVENT_PRODUCT_CARD_STORE_NAME_51',
  EVENT_PRODUCT_CARD_PRODUCT_NAME_52 = 'EVENT_PRODUCT_CARD_PRODUCT_NAME_52',
  EVENT_PRODUCT_CARD_DISCOUNT_53 = 'EVENT_PRODUCT_CARD_DISCOUNT_53',
  EVENT_PRODUCT_CARD_LABEL_54 = 'EVENT_PRODUCT_CARD_LABEL_54',
}

/** @public */
export type CustomAttributeKeys = PDPCustomAttributeKeys | EventCustomAttributeKeys;

/** @public */
export type DataCustomTaKeyAttribute = Pick<HTMLAttributes<HTMLElement>, 'data-custom-ta-key'>;
